
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { BuildWeekPayload, StaticLoadResponse } from "app/data/static-load/model";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { ERROR_MESSAGES } from "app/data/common/errorMessages";

export const useBuildWeek = ( onSuccess: () => void) => {
  return useMutation<
    StaticLoadResponse, // response type
    Error,                // error type
    BuildWeekPayload  // variables type
  >({
    mutationFn: async (payload) => {
      const response = await apiQueryAdapter.query<StaticLoadResponse>(
        "/manifest-management/manifests/build-manifest",
        "POST",
        { body: payload }
      );

      return response.data;
    },
    onSuccess: () => {
      toast.info("Week built successfully");
      onSuccess();
    },
    onError: (e: any) => {
      if (e instanceof Error) {
        toast.error(e.message);
      }
      else if (e?.response?.data?.message) {
        toast.error(e.response.data.message);
      }
      else {
        toast.error(ERROR_MESSAGES.COMMON);
      }
    },
  });
};
